module.exports = __webpack_public_path__ + "img/background_rutsche_w360.f73a76d2.jpg";